<div class="app-download-container">
  <div>
      <!-- <a (click)="goBack()" href="javascript:;" class="flex bg-white gap-2 border-b border-transparent !outline-none hover:border-azulOscuro hover:text-primary">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" class="inline align-middle">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
        Volver
      </a> -->
      <div class="header w-full">
          <div class="logo-container">
              <img src="assets/images/logo/LOGO_tuulApp_Azul.png" alt="Pitzon Logo" class="logo" />
          </div>
      </div>

    <div class="content">
      <div class="info-section">
        <h1 class="title">¡Descarga Pitzon!</h1>
        <p class="subtitle">La app que revoluciona el cuidado de tu vehículo. Encuentra talleres confiables, recibe diagnósticos inteligentes y soluciona problemas al instante.</p>

        <div class="features">
          <div class="feature-item">
            <div class="feature-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <div class="feature-text">
              <h3>⚡ Diagnóstico Instantáneo</h3>
              <p>Identifica problemas de tu vehículo en segundos con nuestra IA avanzada.</p>
            </div>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
            </div>
            <div class="feature-text">
              <h3>📍 Talleres Cercanos</h3>
              <p>Encuentra los mejores talleres cerca de ti con geolocalización inteligente.</p>
            </div>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M9 12l2 2 4-4"></path>
                <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"></path>
                <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"></path>
                <path d="M13 12h3a2 2 0 0 1 2 2v1"></path>
                <path d="M9 12H6a2 2 0 0 0-2 2v1"></path>
              </svg>
            </div>
            <div class="feature-text">
              <h3>🛡️ Talleres Certificados</h3>
              <p>Confía en talleres verificados con calificaciones reales de usuarios.</p>
            </div>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
              </svg>
            </div>
            <div class="feature-text">
              <h3>⭐ Reseñas Reales</h3>
              <p>Lee experiencias de otros usuarios y comparte la tuya.</p>
            </div>
          </div>
        </div>

        <!-- <div class="stats-section">
          <div class="stat-item">
            <div class="stat-number">10K+</div>
            <div class="stat-label">Usuarios Activos</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">500+</div>
            <div class="stat-label">Talleres Verificados</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">4.8★</div>
            <div class="stat-label">Calificación Promedio</div>
          </div>
        </div> -->
      </div>

      <div class="download-section">
        <div class="app-mockup">
          <img src="assets/images/juan1.png" alt="Pitzon App Mockup" class="mockup-image" />
        </div>

        <div class="download-buttons">
          <h2>¡Descarga GRATIS ahora!</h2>
          <p class="download-subtitle">Disponible para Android • iOS</p>
          <div class="buttons">
            <button (click)="downloadIOS()" class="download-btn ios">
              <div class="btn-icon">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyXpY3NEZRVu8RjYTaNFwv4IWF5Vq6YacNiA&s" alt="iOS App Store" />
              </div>
              <div class="btn-text">
                <span class="small-text">iOS</span>
                <span class="large-text">App Store</span>
              </div>
            </button>

            <button (click)="downloadAndroid()" class="download-btn android">
              <div class="btn-icon">
                <img src="https://www.androidp1.com/uploads/posts/2021-09/1630781158_google-play-store.webp" alt="Google Play Store" />
              </div>
              <div class="btn-text">
                <span class="small-text">Android</span>
                <span class="large-text">Google Play</span>
              </div>
              <div class="download-arrow">↓</div>
            </button>
          </div>
          <div class="trust-badges">
            <div class="trust-item">
              <span class="trust-icon">🔒</span>
              <span>100% Seguro</span>
            </div>
            <div class="trust-item">
              <span class="trust-icon">⚡</span>
              <span>Descarga Rápida</span>
            </div>
            <div class="trust-item">
              <span class="trust-icon">📱</span>
              <span>Optimizado</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="footer-links">
        <a href="/term-conditions">Términos y Condiciones</a>
        <a href="#">Política de Privacidad</a>
        <a href="#">Contacto</a>
      </div>
      <div class="copyright">
        <div class="text-white py-4 flex flex-col items-center">
          <p class="flex items-center gap-2">
            Pitzon Web v-1.0.1 Todos los derechos reservados © 2026 by
            <img class="w-20" src="https://tuulapp.com//assets/images/logo/logo.svg" alt="Tuulapp Logo" />
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
